import axios from 'axios'
import { config } from '../shared/app.config'

const RESOURCE_NAME = '/schedule'
const RESOURCE_NAME_CALENDAR = '/calendars'

export default {
  addHoliday(id, data) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME_CALENDAR}/${id}/holidays`, data)
  },
  create(data) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME_CALENDAR}`, data)
  },
  edit(calendar) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}`, calendar)
  },
  update(id, data) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME_CALENDAR}/${id}`, data)
  },
  getConfigCalendar(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/${id}`)
  },
  getCalendar(id, year = '') {
    return axios.get(`${config.webApiBase + RESOURCE_NAME_CALENDAR}/${id}`, {
      params: { year },
    })
  },
  getMyCalendar(year) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME_CALENDAR}/my-calendar`, {
      params: { year },
    })
  },
  holidays(start_date, end_date, client_id, year) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME_CALENDAR}/holidays`, {
      start_date,
      end_date,
      client_id,
      year,
    })
  },
  list(filters) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME_CALENDAR}/list`, filters)
  },
  delete(id) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME_CALENDAR}/${id}`)
  },
  deleteHoliday(id_calendar, id_holiday) {
    return axios.delete(`${config.webApiBase + RESOURCE_NAME_CALENDAR}/${id_calendar}/holidays/${id_holiday}`)
  },
}
